import api from "@/lib/axios";

export const questionService = {
  async getQuestions(userId) {
    const response = await api.post(`/v1/get-questions`, {
      user_id: userId
    });
    console.log('Questions API Response:', response.data);
    return response.data;
  }
}; 